import script from "./ResultsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResultsView.vue?vue&type=script&setup=true&lang=ts"

import "./ResultsView.vue?vue&type=style&index=0&id=14453176&lang=scss"

const __exports__ = script;

export default __exports__